var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-allowed-view"},[_c('h2',{staticClass:"code-error"},[_vm._v(_vm._s(_vm.errorCode))]),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }